"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.06,16.52a.16.16,0,0,1-.1-.28,2.43,2.43,0,0,0,0-4,.16.16,0,1,1,.2-.25,2.74,2.74,0,0,1,0,4.47A.16.16,0,0,1,3.06,16.52Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,15.92a.16.16,0,0,1-.1-.28,1.69,1.69,0,0,0,0-2.76.16.16,0,1,1,.2-.25,2,2,0,0,1,0,3.26A.16.16,0,0,1,2,15.92Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,15.32A.16.16,0,0,1,.92,15a.95.95,0,0,0,0-1.56.16.16,0,0,1,.2-.25,1.27,1.27,0,0,1,0,2.06A.16.16,0,0,1,1,15.32Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.22,11.91a.16.16,0,0,1,.1.28,2.43,2.43,0,0,0,0,4,.16.16,0,1,1-.2.25,2.74,2.74,0,0,1,0-4.47A.16.16,0,0,1,21.22,11.91Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.24,12.51a.16.16,0,0,1,.1.28,1.69,1.69,0,0,0,0,2.76.16.16,0,1,1-.2.25,2,2,0,0,1,0-3.26A.16.16,0,0,1,22.24,12.51Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.26,13.11a.16.16,0,0,1,.1.28.95.95,0,0,0,0,1.56.16.16,0,0,1-.2.25,1.27,1.27,0,0,1,0-2.06A.16.16,0,0,1,23.26,13.11Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.43,9.8a.16.16,0,0,1,.28-.1,2.54,2.54,0,0,0,2,1,2.55,2.55,0,0,0,2-1,.16.16,0,1,1,.25.2,2.74,2.74,0,0,1-4.47,0A.16.16,0,0,1,9.43,9.8Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,8.78a.16.16,0,0,1,.28-.1,1.69,1.69,0,0,0,2.76,0,.16.16,0,1,1,.25.2,2,2,0,0,1-3.26,0A.16.16,0,0,1,10,8.78Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.63,7.76a.16.16,0,0,1,.28-.1.95.95,0,0,0,1.56,0,.16.16,0,0,1,.25.2,1.27,1.27,0,0,1-2.06,0A.16.16,0,0,1,10.63,7.76Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18,17,5.87,17a.22.22,0,0,1-.22-.22l0-4.35a.22.22,0,0,1,.22-.22l12.17,0a.22.22,0,0,1,.22.22l0,4.35A.22.22,0,0,1,18,17Zm-12-.39,11.73,0,0-3.91-11.73,0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.12,17h-1.3a.22.22,0,0,1,0-.43h1.3a.22.22,0,1,1,0,.43Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.09,17H4.78a.22.22,0,0,1,0-.43h1.3a.22.22,0,1,1,0,.43Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.56",
    y: "16.69",
    width: "4.65",
    height: "0.72",
    transform: "translate(-0.07 0.05) rotate(-0.23)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.21,17.61l-4.65,0a.22.22,0,0,1-.22-.22V16.7a.22.22,0,0,1,.22-.22l4.65,0a.22.22,0,0,1,.22.22v.72A.22.22,0,0,1,14.21,17.61ZM9.78,17.2l4.22,0V16.9l-4.22,0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.13,18.71a1.09,1.09,0,1,1,1.08-1.09A1.09,1.09,0,0,1,8.13,18.71Zm0-1.74a.65.65,0,1,0,.65.65A.65.65,0,0,0,8.13,17Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.21,18.71a1.09,1.09,0,1,1,1.08-1.09A1.09,1.09,0,0,1,6.21,18.71Zm0-1.74a.65.65,0,1,0,.65.65A.65.65,0,0,0,6.21,17Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.61,18.67a1.09,1.09,0,1,1,1.08-1.09A1.09,1.09,0,0,1,17.61,18.67Zm0-1.74a.65.65,0,1,0,.65.65A.65.65,0,0,0,17.6,16.93Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.69,18.67a1.09,1.09,0,1,1,1.08-1.09A1.09,1.09,0,0,1,15.69,18.67Zm0-1.74a.65.65,0,1,0,.65.65A.65.65,0,0,0,15.68,16.94Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.47,16.79a.22.22,0,0,1-.22-.22V14.84a.22.22,0,0,1,.43,0v1.74A.22.22,0,0,1,8.47,16.79Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.43,16.76a.22.22,0,0,1-.22-.22V14.81a.22.22,0,0,1,.43,0v1.74A.22.22,0,0,1,15.43,16.76Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78,15.12a.38.38,0,0,1-.39-.38V13.3a.38.38,0,1,1,.77,0v1.44A.38.38,0,0,1,11.78,15.12Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.78,16.22a.38.38,0,0,1-.39-.38.39.39,0,0,1,.38-.39.38.38,0,0,1,.39.37v0A.38.38,0,0,1,11.78,16.22Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.24,17.14a.36.36,0,0,1-.32-.38.36.36,0,0,1,.31-.39.35.35,0,0,1,.32.37v0A.36.36,0,0,1,19.24,17.14Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.47,17.2a.36.36,0,0,1-.32-.38.36.36,0,0,1,.31-.39.35.35,0,0,1,.32.37v0A.36.36,0,0,1,4.47,17.2Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.93,21.41l-2.09-3.25-.7.45,1.68,2.61-21.65.09L2.71,18.8,2,18.36.06,21.52a.42.42,0,0,0,.36.64l23.16-.09a.42.42,0,0,0,.35-.65Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.92,3.1l2.38,4.08L15,6.76,12.28,2.05a.42.42,0,0,0-.36-.21h0a.42.42,0,0,0-.36.21L8.88,6.73l.73.42Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;